"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_library_1 = require("@seneca/client-library");
/**
 * Typed error for subscription service
 * @param {string} message the validation message
 */
class CouldNotUpdateCustomerOnStripeError extends client_library_1.ExtendableError {
    constructor() {
        super('CouldNotUpdateCustomerOnStripe');
    }
}
exports.default = CouldNotUpdateCustomerOnStripeError;
//# sourceMappingURL=CouldNotUpdateCustomerOnStripeError.js.map